<template>
    <span :style="{
        width: `${width}px`,
        minWidth: `${width}px`,
        height: `${height}px`,
        minHeight: `${height}px`,
         }" class="loader"></span>
</template>

<script>
    export default {
        name: "Loader",
        props: ['height', 'width']
    }
</script>

<style scoped>

</style>
